import React from "react";
import * as z from "zod";
import "../../assets/css/adminPages/contact/style.scss";
import DataLoader from "../../components/loader/dataLoader";
import useContacts from "../../hooks/public/useContacts";
import ContactAddModal from "./components/ContactAddModal";
import ContactCard from "./components/contactCard";

const MAX_FILE_SIZE = 1000000;
const ACCEPTED_IMAGE_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/webp",
];

const schema = z.object({
  imageBase64: z
      .any()
      .refine((file) => file instanceof File, `Required`)
      .refine(
          (file) => ACCEPTED_IMAGE_TYPES.includes(file?.type),
          "Only .jpg, .jpeg, .png and .webp formats are supported."
      )
      .refine((file) => file?.size <= MAX_FILE_SIZE, `Max image size is 1MB.`),
  descriptionEn: z
      .string()
      .min(1, {message: "Required"})
      .min(20, {message: "Minimum length is 20"})
      .max(170, {message: "Max length is 170"}),
  email: z
      .string()
      .min(1, {message: "Required"})
      .email({message: "Invalid Email"})
      .max(50, {message: "Max length is 50"}),
});

const Index = () => {
  const {data, isLoading, error, create, update, remove} = useContacts();
  
  if (error) return null;
  return (
      <div className="contact-update-section">
        <div className="custom-container">
          <div className="content-section">
            <h1 className="page-title">Contact</h1>
            <div className="content-body">
              <div className="">
                <ContactAddModal schema={schema} onCreate={create}/>
                {isLoading && <DataLoader/>}
                <div className="row">
                  {
                    data?.map((contact) => (
                        <div key={contact.id} className="col-xl-6">
                          <ContactCard
                              schema={schema}
                              contact={contact}
                              onUpdate={update}
                              onDelete={remove}
                          />
                        </div>
                    ))
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default Index;
